import { observable, action } from "mobx";

export const CommonStore = observable({
  showViewChat: false
});

export const UpdateMessageStore = action(function(message) {
  const store = CommonStore;
  store.message = message;
});

export const AgentCareStore = observable({
  displayPicture: "",
  status: "offline"
});



// WEBPACK FOOTER //
// ./src/Store.js